<template>
  <Fragment>
    <Hero />
    <TwoColumn col1_class="cd_protect" col2_class="cd_preserve">
      <Fragment slot="col1_content">
        <h2>Help Protect</h2>
        <p>Report pollutants such as trash, untreated sewage, suspicious drilling activity and we’ll help you get word out to the appropriate agencies in Monongalia and Preston counties that will remediate the issue</p>
        <div>
          <router-link :to="{ name: 'reportPollution' }" class="btn btn-success btn-lg">
            Report Pollution
          </router-link>
        </div>
      </Fragment>
      <Fragment slot="col2_content">
        <h2>Help Preserve</h2>
        <p>Report fish to help us monitor the health of the watershed. Many fish now thrive in Deckers Creek including in reaches that were once heavily polluted.</p>
        <div>
          <router-link :to="{ name: 'reportFish' }" class="btn btn-success btn-lg">
            Report Fish
          </router-link>
        </div>
      </Fragment>
    </TwoColumn>
    <Partners />
    <Donate />
  </Fragment>
</template>

<script>
  import Hero from '../hero'
  import TwoColumn from '../two-column'
  import Partners from '../partners'
  import Donate from '../donate'
  import {Fragment} from 'vue-fragment'

  export default {
    name: 'Index',
    components: {
      Hero,
      TwoColumn,
      Partners,
      Donate,
      Fragment
    }
  }
</script>
